export const PipelineColorDictionary: { [label: string]: string } = {
  'Prospect': '#009999',
  'Contacted': '#0099CC',
  'Visited': '#9966FF',
  'Proposal': '#FF9900',
  'Won': '#008000',
  'Lost': '#CC3300',
};

export const hexToRgba = (hex: string, alpha:number) => {
  // Remove the # symbol, if present
  hex = hex.replace("#", "");
  // Extract the red, green, and blue components
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  // Convert to RGBA format
  return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
}
